import React from 'react';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import Sponsor from './Sponsor';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/free-regular-svg-icons';

// This is the query that Apollo Client will send to the WP site.
const SPONSORS_QUERY = gql`
query MyQuery {
  sponsors {
    edges {
      node {
        featuredImage {
          altText
          mediaItemUrl
        }
        title
        sponsor_information {
          websiteUrl
        }
      }
    }
  }
}
`;


const SponsorList = () => {
	const { loading, error, data } = useQuery(SPONSORS_QUERY);

	if (loading) return 'Loading...';
	if (error) return `Error! ${error.message}`;

	return (<section className="region sponsors" id="how">
		<h2><FontAwesomeIcon icon={faComments} /> Sponsors</h2>
		<p className="region-intro">This weekend wouldn’t be made possible without the help of our generous sponsors.</p>
		<div className="container">
			<div className="sponsor-grid">
			{data.sponsors.edges.map((edge,key) => {
				return <Sponsor key={key} edge={edge} />
			})}
			</div>
		</div>
	</section>)
};

export default SponsorList;
